import React from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import {
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Button,
  Paper,
  Typography,
} from '@material-ui/core';
import MailingSettings from './MailingSettings';
import MailingReview from './MailingReview';
import MailingWorkflow from './MailingWorkflow';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    button: {
      marginTop: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
    actionsContainer: {
      marginBottom: theme.spacing(2),
    },
    resetContainer: {
      padding: theme.spacing(3),
    },
  })
);

function getSteps() {
  return [
    'Configure mailing provider settings',
    'Create mailing workflow',
    'Create mailing compaign',
  ];
}

function getStepContent(step: number) {
  switch (step) {
    case 0:
      return 'For each mailing campaign that you create, you can control which mailing provider you would like to use.';
    case 1:
      return 'Define your mailing workflow stategy depending on user activity.';
    case 2:
      return 'Review & test your mailing compaign.';
    default:
      return 'Unknown step';
  }
}

const Workflow = () => {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  // const [validStep, setValidStep] = React.useState(false);
  const [currentProvider, setCurrentProvider] = React.useState<string | null>(
    null
  );
  const steps = getSteps();

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  return (
    <div className={classes.root}>
      <Stepper activeStep={activeStep} orientation="vertical">
        {steps.map((label, index) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
            <StepContent>
              <Typography>{getStepContent(index)}</Typography>
              {activeStep === 0 && (
                <MailingSettings
                  currentProvider={currentProvider}
                  setCurrentProvider={setCurrentProvider}
                />
              )}
              {activeStep === 1 && <MailingWorkflow />}
              {activeStep === 2 && <MailingReview />}
              <div className={classes.actionsContainer}>
                <div>
                  <Button
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    className={classes.button}
                  >
                    Back
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleNext}
                    className={classes.button}
                  >
                    {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                  </Button>
                </div>
              </div>
            </StepContent>
          </Step>
        ))}
      </Stepper>
      {activeStep === steps.length && (
        <Paper square elevation={0} className={classes.resetContainer}>
          <Typography>All steps completed - you&apos;re finished</Typography>
          <Button onClick={handleReset} className={classes.button}>
            Reset
          </Button>
        </Paper>
      )}
    </div>
  );
};

export default Workflow;
